'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC, useState } from 'react'

import CheckoutChips, {
    ContributionSize,
    Project,
    WhoPays,
} from '@/components/InteractiveCheckout/CheckoutChips'
import CheckoutImagesDesktop from '@/components/InteractiveCheckout/CheckoutImagesDesktop'
import MobileCarouselCheckout from '@/components/InteractiveCheckout/MobileCarouselCheckout'

const InteractiveCheckout: FC = () => {
    const { mdScreen, smScreen } = useDevice()
    const [selectedChips, setSelectedChips] = useState<(WhoPays | ContributionSize | Project)[]>([])

    return (
        <Box
            sx={{
                display: 'flex',
                gap: smScreen ? 6 : 9,
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: smScreen ? 6 : 3,
                    flexDirection: smScreen ? 'column' : 'row',
                }}
            >
                <Box
                    sx={{
                        flex: '1 1 auto',
                        width: '100%',
                    }}
                >
                    <Text
                        variant={mdScreen ? 'h5' : 'h4'}
                        sx={{ mb: smScreen ? 2 : 6, fontWeight: 700 }}
                    >
                        Green the online checkout
                    </Text>
                    <Text variant={mdScreen ? 'body2' : 'body1'}>
                        Enhance your merchants&apos; digital checkout experience by educating their
                        customers on climate impact. Empower them to integrate climate contributions
                        into each transaction automatically, or by give their customers the chance
                        to opt-in or round up transactions.
                    </Text>
                </Box>
                <Box
                    sx={{
                        flex: '1 1 auto',
                        width: '100%',
                    }}
                >
                    <Text
                        variant={mdScreen ? 'h5' : 'h4'}
                        sx={{ mb: smScreen ? 2 : 6, fontWeight: 700 }}
                    >
                        Transform spare change into climate action
                    </Text>
                    <Text variant={mdScreen ? 'body2' : 'body1'}>
                        Enable your merchants to offer clients a chance to fund vetted climate
                        projects by simply rounding up their purchases at the point of sale. This
                        feature not only enriches the customer experience but also turns spare
                        change into meaningful climate action.
                    </Text>
                </Box>
            </Box>
            <Box
                sx={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    alignItems: 'stretch',
                    gap: 3,
                }}
            >
                {smScreen ? (
                    <MobileCarouselCheckout />
                ) : (
                    <>
                        <CheckoutChips setSelectedChips={setSelectedChips} />
                        <Box
                            sx={{
                                height: '680px',
                                width: '100%',
                                flex: '0 1 auto',
                                position: 'relative',
                                borderRadius: '24px',
                                overflow: 'hidden',
                            }}
                        >
                            <CheckoutImagesDesktop chipSelection={selectedChips} />
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    )
}

export default InteractiveCheckout
